import * as amplitude from '@amplitude/analytics-browser';
import Cookies from 'js-cookie';

import { SEARCH_PARAMS } from 'constants/search-params';
import { getQueryParams } from 'utils';

let keyForAmplitude = '782835376bc29ad0e9445b6c857b69a7';

if (process.env.REACT_APP_NODE_ENV !== 'production') {
  keyForAmplitude = '472fa96b38aaeeffa3e1dc89a5edf8d6';
}

export class AmplitudeAPI {
  static async getInit() {
    const now = Date.now();
    let expiredAt = new Date(now + 90000);
    expiredAt = new Date(expiredAt.getTime() + 90000);
    const sessionID = Cookies.get('sessionID');
    const cookieId = Cookies.get('cookieId');
    const queryId = getQueryParams(SEARCH_PARAMS.ID);

    amplitude.init(keyForAmplitude, {
      defaultTracking: false,
    });

    if (sessionID && cookieId === queryId) {
      AmplitudeAPI.setSessionId(Number(sessionID));

      return null;
    }

    if (!sessionID || (sessionID && cookieId === queryId)) {
      AmplitudeAPI.setSessionId(now);
      Cookies.set('sessionID', now.toString(), { expires: expiredAt });

      if (queryId) {
        Cookies.set('cookieId', queryId, { expires: expiredAt });
      }

      return null;
    }

    return undefined;
  }

  static setSessionId(id: number) {
    amplitude.setSessionId(id);
  }

  static sendLogEvent(event: string, params: { [key: string]: string }) {
    amplitude.logEvent(event, params);
  }
}
